import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatDialogModule} from '@angular/material/dialog';
import {MatIconModule} from '@angular/material/icon';

@NgModule({exports:[
  CommonModule,
  MatToolbarModule ,
  MatDialogModule,
  MatIconModule
]
})
export class MdComponentModule { }
